import type { OrganizationBusinessProfile } from '../../shell/session/domain/businessProfile';
import { allowsHospitality } from '../../shell/feature-flags/businessCapabilitiesService';

/** RPC `get_hospitality_snapshot` exige tables o kitchen_tickets (42501 si no). */
export function orgCanFetchHospitalitySnapshot(
  profile: OrganizationBusinessProfile | null | undefined,
): boolean {
  if (!profile) return true;
  return allowsHospitality(profile);
}
